
























module.exports =
  name: 'destroy_confirmation_modal'
  components:
    balance:      require('components/inside/elements/balance.vue').default
  props:
    trs_length: Number
    account: Object
  computed:
    is_account: -> @account.constructor.className == 'Account'
    last_account: ->
      # Don't allow to delete the very last account
      @is_account && @$store.state.user.accounts.length == 1
